import { render } from "./ChatBot.vue?vue&type=template&id=1306a38a"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__